/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LocationMapIcon20Solid = forwardRef('LocationMapIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.25 4.387 7.75 2.31v13.302l4.5 2.076V4.387Z" }),
        React.createElement("path", { d: "m13.75 17.18 3.488-1.701c.466-.228.762-.701.762-1.22V3.335a.977.977 0 0 0-1.405-.878L13.75 3.844V17.18Z" }),
        React.createElement("path", { d: "M2.762 4.521 6.25 2.82v13.336l-2.844 1.387A.977.977 0 0 1 2 16.665V5.741c0-.519.296-.992.762-1.22Z" })));
});
